import { createSelector } from '@reduxjs/toolkit';

import { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';
import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';
import { Localization } from '@/shared/api/protocol-ts/model/dto_report_localization_pb';

import { assetsModel } from '@/entities/assets';
import { conditionModel } from '@/entities/condition';

export const selectPeriapicalRadiolucencyWithAssetsAndLocalizationsByToothID = (
  toothID: string,
) =>
  createSelector(
    conditionModel.selectors.selectByToothID(toothID),
    assetsModel.selectors.selectAll,
    (
      conditions,
      assets,
    ): Array<{
      condition: Condition;
      assets: Asset[];
      localizations: Localization[];
    }> => {
      const periapicalConditions = conditions.filter(
        (condition) => condition.Code === ConditionCode.PeriapicalRadiolucency,
      );

      return periapicalConditions.map((condition) => {
        const localizations = condition.Localizations || [];
        const assetIDs = [
          ...new Set(
            localizations.map((localization) => localization.TargetAssetID),
          ),
        ];
        const relatedAssets = assets.filter((asset) =>
          assetIDs.includes(asset.ID),
        );

        return {
          condition,
          assets: relatedAssets,
          localizations,
        };
      });
    },
  );
